/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./gwManagement.vue?vue&type=template&id=0056f538"
import script from "./gwManagement.vue?vue&type=script&lang=js"
export * from "./gwManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports